import React, { Component, Fragment } from 'react';
import Layout from 'components/layout';
import Nav from 'components/nav';
import Hero from 'components/hero';
import SignUp from 'components/sign-up';
import Survey from 'components/survey';
import Partners from 'components/partners';
import DynamicData from 'components/dynamic-data';
import Footer from 'components/footer';
import { Consumer } from 'store/createContext';
import ReactGA from 'react-ga';
import cuid from 'cuid';

const USER_ID = cuid();

class Index extends Component {
  componentDidMount() {
    ReactGA.initialize('UA-129299019-1', { gaOptions: { userId: USER_ID } });
    ReactGA.set({ userId: USER_ID });
  }

  render() {
    return (
      <Consumer>
        {({
          steps,
          progress,
          setDynamicLocation,
          setQueryparams,
          queryParams,
          setUserId,
          partners,
          setPartners,
        }) => (
          <Layout>
            <DynamicData
              setDynamicLocation={setDynamicLocation}
              setQueryparams={setQueryparams}
              setUserId={setUserId}
              userId={USER_ID}
              setPartners={setPartners}
              partners={partners}
            />

            <Nav queryParams={queryParams} progress={progress} steps={steps} />
            {queryParams &&
            queryParams.small &&
            queryParams.small === 'true' ? (
              <Fragment>
                <Survey name="survey" queryParams={queryParams} />
              </Fragment>
            ) : (
              <Fragment>
                <Hero queryParams={queryParams} />
                <SignUp queryParams={queryParams} />
                <Survey name="survey" queryParams={queryParams} />
                <Partners />
                <Footer />
              </Fragment>
            )}
          </Layout>
        )}
      </Consumer>
    );
  }
}

export default Index;
